module.exports = __webpack_public_path__ + "media/images/lps-family-f9c338e1.png";